// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__nnPaK","rootCenter":"LoadMoreObserver_rootCenter__SdqBd","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1CjfR"};